import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { addLocaleToHref } from 'lib/utils/helpers';
import { useGlobalModules } from 'contexts';
import styles from './productVariations.module.scss';
import SiteLink from '../../../shared/sitelink';

const ProductVariations = ({ locale, productData, customCallback }) => {
  const router = useRouter();
  const globalModules = useGlobalModules();

  const { slug, size, productVariations } = productData;
  const { chooseVariant } = globalModules.translations.product;

  const allSortedProductVariations = useMemo(
    () =>
      [
        productVariations.length
          ? {
              sizeInteger: parseInt(size.replace('ml', ''), 10),
              size,
              isCurrentProduct: true,
              slug,
            }
          : null,
        ...productVariations.map(v => {
          const sizeInteger = parseInt(v.size.replace('ml', ''), 10);
          return {
            ...v, // size and slug
            sizeInteger,
          };
        }),
      ]
        .filter(v => v?.isCurrentProduct || v?.shopifyData?.variants?.[0]?.price)
        .sort((a, b) => a.sizeInteger - b.sizeInteger),
    [productVariations, slug, size]
  );

  return allSortedProductVariations?.length > 1 ? (
    <>
      <h2 className={styles.productVariationsTitle}>{chooseVariant}</h2>
      <div className={styles.productVariations}>
        {allSortedProductVariations.map(variant => {
          if (variant.isCurrentProduct) {
            return (
              <div
                key={`${variant.slug}-${Math.random()}`}
                className={styles.currentProductVariant}
              >
                <span className={styles.variantSize}>{variant.size}</span>
              </div>
            );
          }

          return (
            <SiteLink
              key={`${variant.slug}-${Math.random()}`}
              className={styles.variantLink}
              href={addLocaleToHref(`p/${variant.slug}`, locale, router)}
            >
              <span className={styles.variantSize}>{variant.size}</span>
            </SiteLink>
          );
        })}
      </div>
      <div className={styles.divider} />
    </>
  ) : null;
};

export default ProductVariations;
